/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListOktaServerSuggestionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOktaServerSuggestionsRequest = {
  /**
   * Include dismissed and installed suggestions.
   */
  includeAll?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListOktaServerSuggestionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOktaServerSuggestionsSecurity$outboundSchema: z.ZodMiniType<
  ListOktaServerSuggestionsSecurity$Outbound,
  ListOktaServerSuggestionsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listOktaServerSuggestionsSecurityToJSON(
  listOktaServerSuggestionsSecurity: ListOktaServerSuggestionsSecurity,
): string {
  return JSON.stringify(
    ListOktaServerSuggestionsSecurity$outboundSchema.parse(
      listOktaServerSuggestionsSecurity,
    ),
  );
}

/** @internal */
export type ListOktaServerSuggestionsRequest$Outbound = {
  include_all: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOktaServerSuggestionsRequest$outboundSchema: z.ZodMiniType<
  ListOktaServerSuggestionsRequest$Outbound,
  ListOktaServerSuggestionsRequest
> = z.pipe(
  z.object({
    includeAll: z._default(z.boolean(), false),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeAll: "include_all",
      gramSession: "Gram-Session",
    });
  }),
);

export function listOktaServerSuggestionsRequestToJSON(
  listOktaServerSuggestionsRequest: ListOktaServerSuggestionsRequest,
): string {
  return JSON.stringify(
    ListOktaServerSuggestionsRequest$outboundSchema.parse(
      listOktaServerSuggestionsRequest,
    ),
  );
}
